import { message, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import {
  deletePriceList,
  refreshTablePriceList,
  setPriceListForUpdate,
  setIsPriceListForUpdate,
} from "../../../redux";
import { DataPriceList } from "../../../redux/@types";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { usePriceList } from "./usePriceList";

const { confirm } = Modal;

export const useTablePriceList = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { tableProps } = usePriceList();

  const changePriceListForUpdate = async (val: DataPriceList) => {
    dispatch(setIsPriceListForUpdate(true));
    navigate(`/priceList/${val.id}`);
  };

  const showDeleteConfirm = (valId: number, val: string) => {
    confirm({
      title: `Estás seguro de borrar la Lista de precios con el id: ${valId}`,
      icon: <ExclamationCircleOutlined />,
      content: `Una vez ejecutada esta acción no hay vuelta atrás, estás por borrar a "${val}", si deseas continuar dale click a "Borrar list. de precios" en caso tal solo oprime en "Cancelar".`,
      okText: "Borrar list. de precios",
      okType: "danger",
      cancelText: "Cancelar",
      keyboard: true,
      maskClosable: true,
      async onOk() {
        await deletePriceList(valId)
          .then(() => {
            dispatch(refreshTablePriceList(true));
            message.success(
              `Se ha borrado con éxito la Lista de precios con id:${valId}`
            );
            tableProps?.refresh();
          })
          .catch((err) => {
            console.log({ err });
            message.error(err.message);
          });
      },
      onCancel() {},
    });
  };

  return {
    //state
    //methods
    //functions
    // changePriceListForUpdate,
    showDeleteConfirm,
    changePriceListForUpdate,
  };
};
